import unescapedText from 'I18n/utils/unescapedText';
/** @TODO add more args here, like properties and associated objects when the BE supports them */
export const invoicesCreateActionTextParser = __action => {
  return unescapedText('copilotToolkit.streamingMessage.invoicesCreate');
};